<template>
  <table class="table table-fixed table-striped table-bordered">
    <tbody>
    <tr v-if="title">
      <th colspan="2">
        <div style="display:flex; flex-direction: row; justify-content: space-between;">
          <span>
            {{ title }}
          </span>
        </div>
      </th>
    </tr>
    <tr v-for="(calculationValue, calculationValueName) in getValues">
      <td>
        <slot :name="`${calculationValueName}.description`" :pretty-name="getPrettyName(calculationValueName)">
          {{ getPrettyName(calculationValueName) }}
          <span v-if="isRequired(calculationValueName)">
            *
          </span>
        </slot>
      </td>
      <td>
        <EditableValue
            :only-show="onlyShow"
            :required="isRequired(calculationValueName)"
            :value="getOverridesValue(getAttributePointer(calculationValueName))"
            @change="editOverridesValue($event,getAttributePointer(calculationValueName))"
            :default-value="calculationValue"
            :pretty-name="getPrettyName(calculationValueName)"
            :type="getType(calculationValueName)"
            :errors="getErrors(calculationValueName)"
            :enum-options="getEnumOptions(calculationValueName)">
          <template v-slot:default="{ defaultValue }">
            <slot :name="`${calculationValueName}.default`" :default-value="defaultValue"></slot>
          </template>
          <template v-slot:input="{ value, updateValue, defaultValue, required }">
            <slot :name="`${calculationValueName}.input`" :value="value" :update-value="updateValue"
                  :default-value="defaultValue" :required="required"></slot>
          </template>
        </EditableValue>
      </td>
    </tr>
    </tbody>
  </table>
</template>

<script>
import EditableValue from './EditableValue';

export default {
  name: 'EditableValuesList',
  props: {
    values: {
      type: Object
    },
    title: {
      type: String,
      required: false
    },
    attributeConfig: {
      type: Object,
      default: {}
    },
    editOverridesValue: {
      type: Function,
      required: true
    },
    getOverridesValue: {
      type: Function,
      required: true
    },
    getErrors: {
      type: Function,
      default: () => 1
    },
    attributePointerPrefix: {
      type: String,
      default: null
    },
    requiredFields: {
      type: Array,
      default: () => []
    },
    notEditableFields: {
      type: Array,
      default: () => []
    },
    onlyShow: {
      type: Boolean,
      default: false
    }
  },
  components: {
    EditableValue
  },
  data() {
    return {
      showOptional: true
    }
  },
  methods: {
    getPrettyName(attribute) {
      if (this.attributeConfig.hasOwnProperty(attribute) && this.attributeConfig[attribute].hasOwnProperty("prettyName")) {
        return this.attributeConfig[attribute].prettyName;
      }
      return attribute;
    },
    getEnumOptions(attribute) {
      if (this.attributeConfig.hasOwnProperty(attribute) && this.attributeConfig[attribute].hasOwnProperty("enumOptions")) {
        return this.attributeConfig[attribute].enumOptions;
      }
      return null;
    },
    getType(attribute) {
      if (this.attributeConfig.hasOwnProperty(attribute) && this.attributeConfig[attribute].hasOwnProperty("type")) {
        return this.attributeConfig[attribute].type;
      }
      return null;
    },
    isRequired(attribute) {
      return this.requiredFields.includes(attribute);
    },
    pascalCase(str) {
      const camelCase = _.camelCase(str);

      return camelCase.charAt(0).toUpperCase() + camelCase.slice(1);
    },
    getAttributePointer(calculationValueName) {
      if (this.attributePointerPrefix) {
        return this.attributePointerPrefix + '.' + calculationValueName;
      } else {
        return calculationValueName;
      }
    },
  },
  computed: {
    getValues() {
      return this.values ? _.pickBy(this.values, (value, key) => {
        return value || !this.notEditableFields.includes(key)
      }) : {}
    },
  }
}
</script>

<style scoped>

</style>
